import React from 'react'
import { Link } from 'react-router-dom'
import Logo from '../components/Logo'

const Footer: React.FC = () => {
  return (
    <footer className="bg-white shadow-sm border-t border-gray-200 flex-shrink-0 py-6 px-3 sm:px-3 lg:px-4">
      <div className="mx-auto">
        <div className="flex flex-col md:flex-row justify-between items-center gap-4">
          <div className="flex items-center gap-2">
            <Link to="/">
              <Logo />
            </Link>
          </div>
          <div className="flex flex-col md:flex-row justify-center items-center gap-6 text-sm text-gray-600">
            <Link to="/about" className="hover:text-blue-600">
              About
            </Link>
            {/* <Link to="/pricing" className="hover:text-blue-600">
              Pricing
            </Link> */}
            <Link to="/terms-of-service" className="hover:text-blue-600">
              Terms of Service
            </Link>
            <Link
              to="/data-processing-addendum"
              className="hover:text-blue-600"
            >
              Data Processing Addendum
            </Link>
            <Link to="/privacy-policy" className="hover:text-blue-600">
              Privacy Policy
            </Link>
            <Link
              to="https://trackiep.mintlify.app/index"
              className="hover:text-blue-600"
            >
              Help Documentation
            </Link>
          </div>
          <div className="text-sm text-gray-500">
            © {new Date().getFullYear()} TrackIEP
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer
